import { render, staticRenderFns } from "./GMCStatsDialog.vue?vue&type=template&id=6f9478c5&"
import script from "./GMCStatsDialog.vue?vue&type=script&lang=js&"
export * from "./GMCStatsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports